import { SmartSendCsvFieldMap } from './SmartSendCsvFieldMap';
import { CsvRawDataRow } from './CsvRawDataRow';
import { MappableSmartSendCsvFields } from './MappableSmartSendCsvFields';

export interface CsvHeaderRow {
  field: string;
  index: number;
}

function mapField(match: string[], field: string) {
  return match.map((x) => x.toLowerCase()).includes(field.toLowerCase());
}

export function GetHeaders(data: CsvRawDataRow[]): CsvHeaderRow[] {
  return GetHeaderRow(data).map((r, i) => {
    return { field: r, index: i };
  });
}

export function GetHeaderRow(data: CsvRawDataRow[]): string[] {
  return data[0].data;
}

export interface CsvFieldAnalysis {
  field: string;
  index: number;
  exists: boolean;
  saveMapping: boolean;
}

export function GetUnmappedFileFields(data: CsvRawDataRow[]): CsvFieldAnalysis[] {
  const headers = GetHeaders(data);
  return headers
    .map((header, index) => {
      return {
        field: header.field,
        index: index,
        saveMapping: false,
        exists: !!GetFieldData(
          header.field,
          MappableSmartSendCsvFields.map((mh, i) => {
            return { field: mh, index: i };
          }),
          MappableSmartSendCsvFields
        )
      };
    })
    .filter((x) => !x.exists && x.field);
}

export function GetUnmappedFields(data: CsvRawDataRow[]): CsvFieldAnalysis[] {
  const headers = GetHeaders(data);
  return MappableSmartSendCsvFields.map((mf, index) => {
    return {
      field: mf,
      index,
      saveMapping: false,
      exists: !!GetFieldData(
        mf,
        headers,
        headers.map((x) => x.field)
      )
    };
  }).filter((x) => !x.exists);
}

/// This allows reverse mapping and direct mapping
export function GetFieldData(field: string, header: CsvHeaderRow[], data: string[]) {
  const index = header.find((x) => {
    const m = SmartSendCsvFieldMap.find((i) =>
      i.fields.map((f) => f.toLocaleLowerCase()).includes(field.toLocaleLowerCase())
    );
    if (m) {
      return mapField([field, ...m.fields], x.field);
    }
    return false;
  })?.index;

  const val = (data[index] || '').trimStart().trimEnd();
  if (val == 'NULL' || val == 'null' || val == 'undefined' || val == 'UNDEFINED') {
    return '';
  }
  return val;
}

export function GetFieldDataExtra(field: string, header: CsvHeaderRow[], data: string[]): boolean {
  const val = (GetFieldData(field, header, data) || '').toLowerCase();
  return val == 'true' || val == '1' || val == 'y' || val == 'yes' || val == 't';
}
